import type { RouteDef } from '../router';
import { getFaq } from '../data/faq';
import { faqPageHtml } from '@roamzy/shared';

// FAQ JSON-LD moved to backend/src/util/json-ld.ts (single SSR source of
// truth since 2026-05-07). Frontend no longer emits its own jsonLd —
// router.ts setMeta() does not touch <script id="ld-json"> on route
// changes; server-injected payload sticks for the lifetime of the page.

const faq: RouteDef = {
  path: '/faq',
  routeType: 'faq',
  navKey: 'faq',
  metaTitle: 'FAQ — Frequently Asked Questions | Roamzy',
  metaDesc: 'Answers to common questions about Roamzy — pay-per-MB billing, stablecoin payments, device compatibility, setup, and support.',
  // The server sends this page (backend faq-body.ts, the same renderer); the
  // router keeps it on first paint.
  prerenderMarker: '.faq-route',
  hydrate: () => '',
  render() {
    const { labels, qas } = getFaq();
    return `<div class="faq-route">${faqPageHtml({ labels: labels as unknown as Record<string, string>, qas })}</div>`;
  },
  mount(root) {
    const filters = root.querySelectorAll<HTMLButtonElement>('.faq-filter');
    const groups = root.querySelectorAll<HTMLElement>('.faq-group');
    const onClick = (e: Event): void => {
      const btn = e.currentTarget as HTMLButtonElement;
      filters.forEach((b) => b.classList.remove('faq-filter--active'));
      btn.classList.add('faq-filter--active');
      const cat = btn.dataset.cat || 'all';
      groups.forEach((g) => {
        g.hidden = cat !== 'all' && g.dataset.group !== cat;
      });
    };
    filters.forEach((b) => b.addEventListener('click', onClick));
    return () => filters.forEach((b) => b.removeEventListener('click', onClick));
  },
};

export default faq;
